import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "react-custom-checkbox";
class CustomCheckbox extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.any,
  };

  static defaultProps = {
    className: 'icheckbox_minimal-blue'
  };

  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    }
  }

  UNSAFE_componentWillMount() {
    const { checked } = this.props;
    this.setState({ isChecked: checked === true });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { checked } = nextProps;
    this.setState({ isChecked: checked === true });
  }

  handleOnChange = () => {
    this.setState({ isChecked: !this.state.isChecked });
    return !this.state.isChecked;
  }

  render() {
    const { name, value, onChange, className, containerClassName, label } = this.props;
    const { isChecked } = this.state;

    return (
      <Checkbox
        className={className}
        icon={<span className='checkBoxChecked' />}
        checked={isChecked}
        name={name}
        value={value}
        label={label}
        labelStyle={{ margin: 0 }}
        containerClassName={containerClassName}
        onChange={() => onChange(this.handleOnChange())}
      />
    )
  }
}

export default CustomCheckbox;
